import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./logo";
import Cookies from "js-cookie";

function Header() {
  const userImage = Cookies.get("image_url");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // State to manage mobile menu visibility

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="font-epilogue flex justify-between items-center px-4 sm:px-6 md:px-8 lg:px-32 py-4 mb-0 bg-slate-50 sticky max-sm:fixed top-0 z-30 max-sm:left-0 max-sm:right-0 max-sm:box-border">
      <div className="flex items-center gap-6 sm:gap-8 md:gap-12">
        <Logo />

        {/* Desktop Navigation */}
        <nav className="hidden md:flex gap-8">
          <Link
            to="/"
            className="text-md font-medium text-slate-600 hover:text-indigo-600 hover:font-semibold transition duration-300"
          >
            Home
          </Link>
          <Link
            to="/vacancies"
            className="text-md font-medium text-slate-600 hover:text-indigo-600 hover:font-semibold transition duration-300"
          >
            Vacancies
          </Link>
        </nav>
      </div>

      <div className="flex items-center gap-4">
        {userImage ? (
          // Show both the user profile image and the menu on mobile
          <>
            <div className="flex items-center sm:hidden">
              <button
                className="p-2 text-slate-600 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={toggleMobileMenu}
                aria-label="Toggle mobile menu"
              >
                {/* Hamburger menu icon */}
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  ></path>
                </svg>
              </button>
            </div>
            {/* Show image and menu links */}
            <div className="flex items-center gap-4">
              <Link to="/dashboard/profile">
                <img
                  className="w-10 h-10 rounded-full border-2 border-indigo-600"
                  src={userImage}
                  alt="User avatar"
                />
              </Link>
            </div>
          </>
        ) : (
          <>
            {/* Mobile Menu Button (Hamburger Icon) */}
            <button
              className="md:hidden p-2 text-slate-600 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              {/* You can replace this with an actual SVG icon for a hamburger */}
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
            </button>

            {/* Desktop Login/Signup Buttons */}
            <div className="hidden md:flex items-center">
              <Link
                to="/login"
                className="px-6 py-3 text-base font-semibold text-indigo-600 hover:bg-indigo-100 transition duration-300"
              >
                Login
              </Link>
              <div className="mx-4 w-0.5 h-6 bg-zinc-200" />
              <Link
                to="/signup"
                className="px-6 py-3 text-base font-semibold text-white bg-indigo-600 hover:bg-indigo-700 transition duration-300"
              >
                Sign Up
              </Link>
            </div>
          </>
        )}
      </div>

      {/* Mobile Navigation (appears when isMobileMenuOpen is true) */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-slate-50 shadow-lg py-4">
          <nav className="flex flex-col items-center gap-4">
            <Link
              to="/"
              className="text-lg font-medium text-slate-600 hover:text-indigo-600 hover:font-semibold transition duration-300 w-full text-center py-2"
              onClick={toggleMobileMenu}
            >
              Home
            </Link>
            <Link
              to="/vacancies"
              className="text-lg font-medium text-slate-600 hover:text-indigo-600 hover:font-semibold transition duration-300 w-full text-center py-2"
              onClick={toggleMobileMenu}
            >
              Vacancies
            </Link>
            {!userImage && (
              <>
                <Link
                  to="/login"
                  className="px-6 py-3 text-base font-semibold text-indigo-600 hover:bg-indigo-100 transition duration-300 w-full text-center"
                  onClick={toggleMobileMenu}
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="px-6 py-3 text-base font-semibold text-white bg-indigo-600 hover:bg-indigo-700 transition duration-300 w-full text-center"
                  onClick={toggleMobileMenu}
                >
                  Sign Up
                </Link>
              </>
            )}
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;
